import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PdfView } from "@/components/PdfView";
import { api, errText } from "@/lib/api";

const IMG = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];

async function loadPreview(m) {
  if (m.ext === "docx" || m.ext === "pptx") {
    const { data } = await api.get(`/materials/${m.id}/preview`);
    return { html: data.html };
  }
  if (!IMG.includes(m.ext) && m.ext !== "pdf" && m.ext !== "txt") return { unsupported: true };
  const r = await api.get(`/materials/${m.id}/download`, { params: { inline: true }, responseType: "blob" });
  if (m.ext === "txt") return { text: await r.data.text() };
  if (m.ext === "pdf") return { pdf: r.data };
  return { url: URL.createObjectURL(r.data) };
}

function Body({ m, state }) {
  if (state.loading) return <p className="text-sm text-[#6b8a7b]">Загрузка...</p>;
  if (state.error) return <p className="text-sm text-red-600">{state.error}</p>;
  if (state.unsupported) return <p className="text-sm text-[#4b6b5c]" data-testid="viewer-unsupported">Старый формат {m.ext.toUpperCase()} нельзя открыть на сайте. Попросите автора загрузить его в формате {m.ext === "doc" ? "DOCX или PDF" : "PPTX или PDF"}.</p>;
  if (state.text != null) return <pre className="whitespace-pre-wrap text-sm bg-[#f3f9f5] rounded-xl p-4 max-h-[70vh] overflow-auto select-none" data-testid="viewer-text">{state.text}</pre>;
  if (state.pdf) return <PdfView blob={state.pdf} />;
  if (state.html != null) return <div className="doc-preview max-h-[70vh] overflow-y-auto select-none bg-white rounded-xl border p-4 sm:p-6" data-testid="viewer-html" dangerouslySetInnerHTML={{ __html: state.html }} />;
  if (state.url) return <img src={state.url} alt={m.title} className="max-h-[70vh] mx-auto rounded-lg select-none pointer-events-none" data-testid="viewer-image" />;
  return null;
}

export function ViewerDialog({ m, onClose }) {
  const [shown, setShown] = useState(null);
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    if (!m) return undefined;
    let url = null;
    let alive = true;
    setShown(m);
    setState({ loading: true });
    loadPreview(m)
      .then((s) => { url = s.url || null; if (alive) setState(s); })
      .catch((e) => alive && setState({ error: errText(e) }));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [m]);

  return (
    <Dialog open={!!m} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-4xl" data-testid="viewer-dialog">
        <DialogHeader>
          <DialogTitle className="font-display pr-6">{shown?.title}</DialogTitle>
          <DialogDescription>Просмотр на сайте</DialogDescription>
        </DialogHeader>
        <div className="min-h-[200px]" onContextMenu={(e) => e.preventDefault()}>
          {shown && <Body m={shown} state={state} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
